import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Redirect, Route, Switch } from '@treams/treams-routes';
import { Jumbo, Tabs } from '@treams/treams-ui';

import NotificationsEmailEditor from './notifications/NotificationsEmailEditor';
import SentEmailsListContainer from 'packages/kakapo-ui-settings-application/pages/emails/SentEmailsListContainer';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

export default function EmailsSettings() {
	const { t } = useTranslation();

	const { username } = useAuthenticatedUser();

	return (
		<>
			<Jumbo
				title={t('settings.notifications.title')}
				description={t('settings.notifications.description')}
				footer={
					<Tabs.Container mb="-1px" wide={1080}>
						<Tabs.Item
							title={t('settings.notifications.email.title')}
							path="/settings/notifications/email"
						/>
						{username === 'support' && (
							<Tabs.Item
								title={t('settings.emails.sent.title')}
								path="/settings/notifications/sent-emails"
							/>
						)}
					</Tabs.Container>
				}
				wide={1080}
			/>
			<Switch>
				<Route path="/settings/notifications/email">
					<NotificationsEmailEditor />
				</Route>
				<Route path="/settings/notifications/sent-emails">
					<Box p={4}>
						<SentEmailsListContainer />
					</Box>
				</Route>
				<Route>
					<Redirect to="/settings/notifications/email" />
				</Route>
			</Switch>
		</>
	);
}
